import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { BottomNudgeVO } from '@domain/vo/NudgeVO';
import useScroll from '@utils/hooks/useScroll';
import LocalStorageUtil from '@utils/storage/localStorage';

import classnames from 'classnames/bind';
import styles from './bottomNudge.module.scss';
const cx = classnames.bind(styles);

const STORAGE_KEY = 'permanentlyClosedNudges';

interface Props {
  bottomNudges: Map<string, BottomNudgeVO>;
}

const BottomNudge = ({ bottomNudges }: Props) => {
  const { asPath: pathname } = useRouter();

  const getBottomNudgeByPath = (path: string) => {
    if (bottomNudges.has(path)) return bottomNudges.get(path);
    if (bottomNudges.has('global')) return bottomNudges.get('global');
    return null;
  };

  const getIsPermantlyClosedNudge = (nudgeSn: number) => {
    const rawNudges = LocalStorageUtil.getItem(STORAGE_KEY);
    const nudges: number[] | null = rawNudges ? JSON.parse(rawNudges) : null;
    if (nudges === null) return false;
    return nudges.includes(nudgeSn);
  };

  const setIsPermantlyClosedNudge = (nudgeSn: number, permanentlyClosed: boolean) => {
    const rawNudges = LocalStorageUtil.getItem(STORAGE_KEY);
    let nudges: number[] = rawNudges ? JSON.parse(rawNudges) : [];
    if (nudges === null) return;
    if (permanentlyClosed) {
      if (nudges.includes(nudgeSn)) return;
      nudges.push(nudgeSn);
    } else {
      nudges = nudges.filter((nudge) => nudge !== nudgeSn);
    }
    LocalStorageUtil.setItem(STORAGE_KEY, JSON.stringify(nudges));
  };

  const [bottomNudge, setBottomNudge] = useState<BottomNudgeVO | null>(null);
  const [isAlert, setIsAlert] = useState(false);
  const [isCloseNudge, setIsCloseNudge] = useState(false);

  useEffect(() => {
    if (!bottomNudge) return;

    const isCloseBottomNudge = getIsPermantlyClosedNudge(bottomNudge.sn);
    setIsCloseNudge(isCloseBottomNudge);
  }, [bottomNudge]);

  useScroll(() => setIsAlert(true), 100, 50);

  useEffect(() => {
    setBottomNudge(getBottomNudgeByPath(pathname) ?? null);
  }, [bottomNudges.size, pathname]); // Map만 dependency로 두면 rerender안됨,	,

  if (bottomNudge === null) return null;
  const { link, thumbnailImageImgPath, sn } = bottomNudge;

  const onCloseBottomNudge = () => {
    setIsCloseNudge(true);
  };

  const onPermanentCloseBottomNudge = () => {
    setIsPermantlyClosedNudge(sn, true);
    setIsCloseNudge(true);
  };

  return (
    <>
      {isAlert && !isCloseNudge && (
        <div className={cx('popupNudge')}>
          <div className={cx('layerArea')}>
            <a href={link} className={cx('link')}>
              <img src={thumbnailImageImgPath} alt="" className={cx('imgNudge')} />
            </a>
            <button className={cx('btnClose')} onClick={onCloseBottomNudge}>
              <span className={cx('hidden')}>닫기</span>
            </button>
          </div>
          <div className={cx('btnArea')}>
            <button className={cx('btn')} onClick={onPermanentCloseBottomNudge}>
              다시 보지 않기
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default BottomNudge;
